/** Onde o prestador encontra o recurso (plano, seção 6.1). */

export const ENTRY_PROFILE_CARD = {
  title: 'Receba sem precisar confirmar',
  body: 'O cliente paga no link da cobrança e o dinheiro cai sozinho na sua conta.',
  ctaLabel: 'Ver como funciona',
};

/** Faixa em Cobranças, depois do 5º pagamento confirmado na mão no mês (fechável, lembra por 30 dias). */
export const ENTRY_CHARGES_BANNER = {
  title: (confirmedCount: number) =>
    `Você confirmou ${confirmedCount} pagamentos este mês. Quer que isso aconteça sozinho?`,
  ctaLabel: 'Ver como funciona',
};

export const ENTRY_SIDEBAR_LABEL = 'Recebimentos';

/**
 * Card do Perfil de quem não ativa por conta própria — caixa único, não é o
 * dono (T7.2, plano 4.7): sem conta ainda, não pode ser convidado a ativar
 * (só o dono faz isso), então explica onde o dinheiro cai em vez de sumir.
 */
export const ENTRY_PROFILE_CARD_SINGLE_TILL = {
  title: 'Recebimento automático',
  body: 'Os pagamentos caem na conta do negócio.',
};
